import { render, staticRenderFns } from "./notice-bar.vue?vue&type=template&id=88e9d060&scoped=true"
import script from "./notice-bar.vue?vue&type=script&lang=js"
export * from "./notice-bar.vue?vue&type=script&lang=js"
import style0 from "./notice-bar.vue?vue&type=style&index=0&id=88e9d060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e9d060",
  null
  
)

export default component.exports